export default class cookie_class {

    setCookie (name, json) {
      // console.info('setcookie');
      let cookieValue = '';
      let expire = '';
      let period = '';
      
      //Specify the cookie name and value
      cookieValue = name + '=' + json + ';';
      
      //Specify the path to set the cookie
      cookieValue += 'path=/ ;';
      
      //Specify how long you want to keep cookie
      period = 30; //days to store
      expire = new Date();
      expire.setTime(expire.getTime() + 1000 * 3600 * 24 * period);
      expire.toUTCString();
      cookieValue += 'expires=' + expire + ';';
      
      //Set cookie
      document.cookie = cookieValue;
      // console.info('setcookie end');
    }
    
    //   getCookie (){
  //  
  //      let cookieValue = '';
  //      let cookieArray = new Array();
  //      let result = new Array();
  //    
  //      //Get cookie
  //      cookieValue = document.cookie;
  //    
  //      //Divide the cookie into an array and convert them to JSON
  //      if(cookieValue){
    //        cookieArray = cookieValue.split(';');
    //          
    //        cookieArray.forEach(data => {
      //          data = data.split('=');
      //    
      //          //data[0]: Cookie name
      //          //data[1]: Cookie value
  //    
  //          result[data[0]] = JSON.parse(data[1]);
  //        });
  //      }
  //      return result;
  //    }
  
  getCookie(cname) {
    // console.info('getcookie');
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      // console.info('getcookie end for');
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        // console.info('getcookie while');
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        // console.info('getcookie  if');
        return c.substring(name.length, c.length);
      }
    }
    // console.info('getcookie end');
    return "";
  }
  product_number(name){
    let t = this.getCookie(name);
    if (t.length == 0 ){
      return 0;
    }else{
      let ta = JSON.parse(t);
      let a_e = [];
      ta.forEach(element => {
        a_e.push(element.prodotto);
      });
      return a_e.length;
    }
  }
  
  
  pushCookie(name, value_str){
    // console.info('pushcookie');
    let t = this.getCookie(name);
    if (t.length == 0 ){
      console.info('non esiste la variabile aggiungo un array');
      let k = '[{"prodotto":' + value_str + '}]';
      this.setCookie(name, k);
      return 1;
    }else{
      console.info('ho trovato array, '+t+'adesso lo converto in oggetto');
      let ta = JSON.parse(t);
      console.info('convertito in array', ta);
      console.info('converto la stringa in arrivo in oggetto');
      let r = '{"prodotto":'+value_str+'}';
      let vs = JSON.parse(r);
      console.info('aggiungo vs', vs, 'a ta', ta);
      let a_e = [];
      ta.forEach(element => {
        a_e.push(element.prodotto);
      });

      if (!a_e.includes(vs.prodotto)){
        ta.push(vs);
        console.info('non include', vs);
        console.info('risultato', ta);
        console.info('riconverto ta');
        let vs_str = JSON.stringify(ta);
        this.setCookie(name, vs_str);
      }else{
        console.info('include gia');
      }
    
      // console.info('pushcookie end');
      return ta.length;
    }
    
  }
}